import messages from '~/locales/messages'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'pl',
  strictMessage: false,
  warnHtmlMessage: false,
  messages: messages,
}))